import { Users, BookOpen, GraduationCap, FlaskConical, Microscope, Award } from "lucide-react"
import type { ClassData } from "../../../../lib/classes-data"

interface ClassCardHeaderProps {
  classData: ClassData
}

const iconMap = {
  users: Users,
  "book-open": BookOpen,
  "graduation-cap": GraduationCap,
  "flask-conical": FlaskConical,
  microscope: Microscope,
  award: Award,
}

export function ClassCardHeader({ classData }: ClassCardHeaderProps) {
  const Icon = iconMap[classData.icon]
  const iconBgColor = classData.borderColor === "primary" ? "bg-teal-50" : "bg-blue-50"
  const iconColor = classData.borderColor === "primary" ? "text-[#21a193]" : "text-[#284e8c]"

  return (
    <div className="flex justify-between items-start mb-4">
      <div>
        <h2 className="text-2xl font-bold text-[#284e8c]">{classData.name}</h2>
        <span className="text-xs font-mono text-gray-400 uppercase tracking-wide">ID: {classData.classId}</span>
      </div>
      <div className={`${iconBgColor} p-2 rounded-lg`}>
        <Icon className={`w-6 h-6 ${iconColor}`} />
      </div>
    </div>
  )
}
